import { render, staticRenderFns } from "./NoticeComponent.vue?vue&type=template&id=296c6083&scoped=true"
import script from "./NoticeComponent.vue?vue&type=script&lang=js"
export * from "./NoticeComponent.vue?vue&type=script&lang=js"
import style0 from "./NoticeComponent.vue?vue&type=style&index=0&id=296c6083&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c6083",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296c6083')) {
      api.createRecord('296c6083', component.options)
    } else {
      api.reload('296c6083', component.options)
    }
    module.hot.accept("./NoticeComponent.vue?vue&type=template&id=296c6083&scoped=true", function () {
      api.rerender('296c6083', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/NoticeComponent.vue"
export default component.exports